import axios from 'axios'
import apiList from './resource.js'
import newApi from "./newApi";
export default {
  // 查询用户学习计划
  getUserStudyPlan: function (data, successfn, errorfn) {
    return axios
        .post(newApi.getAjaxUrl('openapi', 'qryUserStudyPlan'), data)
        .then(res => {
          successfn && successfn(res.data)
        })
        .catch(res => {
          errorfn && errorfn(res.data)
        })
  },
  // 新增用户学习计划
  addStudyPlan: function (data, successfn, errorfn) {
      return axios
          .post(newApi.getAjaxUrl('openapi', 'addStudyPlan'), data)
          .then(res => {
              successfn && successfn(res.data)
          })
          .catch(res => {
              errorfn && errorfn(res.data)
          })
  },
  // 获取用户学习历史
  getLearnHistory: function (data, successfn, errorfn) {
    return axios
      .get(apiList.study.historyList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 清空用户学习历史
  clearLearnHistory: function (successfn, errorfn) {
    return axios.get(apiList.study.clearHistory)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 用户购买记录
  userBuyCourse: function (data, successfn, errorfn) {
    return axios.get(apiList.study.userBuyCourseLists, { params: data })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/study.js